import React from 'react';
import { FaPlus } from 'react-icons/fa';
import '../styles/Projects.css';

const AdminProjects = () => {
  const projects = ['Modern Villa Electrical','Commercial Solar Farm','Factory CCTV Security','Hotel Network Setup','Estate Electric Fence','Apartment Electrical Design'];
  return (
    <div className="projects-page">
      <h1>Projects</h1>
      <p>Manage your project portfolio.</p>
      <button className="add-btn"><FaPlus /> Add Project</button>
      <table className="projects-table">
        <thead><tr><th>#</th><th>Project</th><th>Category</th><th>Client</th><th>Actions</th></tr></thead>
        <tbody>{projects.map((p,i)=>(<tr key={i}><td>{i+1}</td><td>{p}</td><td>{i%2===0?'Residential':'Commercial'}</td><td>Client Name</td><td><button className="edit-btn">Edit</button> <button className="delete-btn">Delete</button></td></tr>))}</tbody>
      </table>
    </div>
  );
};
export default AdminProjects;
